<template>
  <div class="mine_layout clearfix">
<!--    <mine-menu/>-->
    <div class="mine__content">
      <header class="mine-top-header">
        <ui-logo :target="'domain'" :is-logo-white="false" isHorizontal/>
        <h1 class="title"><i class="icon icon--mine"></i>Mine</h1>
        <span class="title-desc">{{ $t('mine.header.titleDesc') }}</span>
        <a href="#" class="btn__gnb" @click.stop.prevent="toggleUserMenu">
          <i class="icon icon--user"></i>
        </a>
        <!-- user depth menu -->
        <div class="gnb__navigation" v-if="showUserMenu">
          <div class="home" @click="goBridge" v-if="!isDemo">
            <div class="home__icon" />
            <span class="home__text">Home</span>
          </div>
          <div class="user-name" v-if="!isDemo">
            <span>{{ userData.userId }}</span>
            <router-link to="/user/myinformation">
              <i class="icon icon--setting"/>
            </router-link>
          </div>
          <ul>
            <li class="item__title"  v-if="!isDemo">
              <span>UX Heatmap</span>
            </li>
            <li v-for="(item, index) in myInfoPage" :key="index">
              <router-link :to="{ name: item }" class="item item__link">{{ $t(`userInfo.lnb.${item}`) }}</router-link>
            </li>
            <li class="item--common" v-if="userData.isGmc">
              <router-link to="/user/jam" class="item item__link">{{ $t(`userInfo.lnb.jam`) }}</router-link>
            </li>
            <li v-if="!isDemo">
              <router-link to="/user/myinformation" class="item item__link">{{ $t(`userInfo.lnb.myInformation`) }}</router-link>
            </li>
            <li class="item__signout"><a href="#" class="item signout"
                                         @click.prevent="onSignOutClick">{{ $t('gnb.user.logout') }}</a></li>
            <li class="item__language">
              <span class="item item-language" @click.stop.prevent="showLanguageList(false)">{{ $t('gnb.user.language') }}</span>
              <div class="language--wrap">
                  <span class="current-language" @click.stop.prevent="showLanguageList(true)">
                    <i class="icon icon--lang" :class="currentLocale"></i>
                    {{ currentLocale.toUpperCase() }}
                  </span>
                <i class="icon icon--drop-down"></i>
                <transition name="slide">
                  <ul class="language__list" :class="{'is-show': showLanguageListStatus}" v-show="showLanguageListStatus">
                    <li v-for="item in localeData" :key="item.code"
                        :class="{ [item.code]: true, on: item.code === currentLocale }"
                        :title="item.title"
                        @click="onLocaleClick(item.code)">
                      <i class="icon icon--lang" :class="item.code"></i> {{ item.code.toUpperCase() }}
                    </li>
                  </ul>
                </transition>
              </div>
            </li>
          </ul>
        </div>
      </header>
      <router-view class="content"/>
    </div>
  </div>
</template>
<script>
import MineMenu from '@/components/mine/MineMenu.vue'
import { EventBus } from '@/libs/event-bus'
import { mapMutations, mapState } from 'vuex'
import { SIGNIN_LINK } from '@/libs/constants'
import { changeLocale } from '@/libs/i18n'
import UiLogo from '@/components/ui/UiLogo.vue'

export default {
  name: 'MineLayout',
  components: { UiLogo, MineMenu },
  data () {
    return {
      showLanguageListStatus: false
    }
  },
  computed: {
    ...mapState([
      'userData',
      'planData',
      'showUserMenu',
      'isDemo'
    ]),
    myInfoPage () {
      if (this.userData.isGmc) {
        return [
          'managePlan',
          'requestManagement',
          'userManagement',
          'pageManagement',
          'ipBlocking'
        ]
      } else {
        return [
          'ipBlocking'
        ]
      }
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  mounted () {
    EventBus.$on('closeUserMenu', () => {
      this.setShowUserMenu(false)
      this.showLanguageListStatus = false
    })
  },
  created () {
    this.localeData = [
      {
        code: 'ja',
        title: 'Japanese'
      },
      {
        code: 'en',
        title: 'English'
      },
      {
        code: 'ko',
        title: 'Korean'
      }
    ]
  },
  methods: {
    ...mapMutations([
      'setShowUserMenu'
    ]),
    toggleUserMenu () {
      this.setShowUserMenu(!this.showUserMenu)
      this.showLanguageListStatus = false
    },
    showLanguageList (status) {
      status ? this.showLanguageListStatus = true : this.showLanguageListStatus = false
    },
    onSignOutClick () {
      this.$root.$children[0].signOut()
      window.location.href = SIGNIN_LINK
    },
    onLocaleClick (locale) {
      changeLocale(this.$i18n, locale)
    },
    goBridge () {
      window.location.href = SIGNIN_LINK.replace('signin', 'my')
    }
  }
}
</script>
<style scoped lang="scss">
.mine_layout {
  min-width: 1280px;
  display: flex;
  align-items: flex-start;
  font-family: "Pretendard Variable", sans-serif;

  .mine__content {
    width: 100%;
    overflow: hidden;
    height: 100%;

    .logo-layout {
      width: auto;
    }
  }

  .mine-top-header {
    width: calc(100% - 40px);
    padding: 16px 20px 14px;
    background: #FFF;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.06);
    display: flex;
    align-items: center;
    gap: 20px;
    position: relative;
    z-index: 11;

    .btn__gnb {
      margin-left: auto;
      .icon {
        position: relative;
        &:hover {
          &:after {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: block;
            content: '';
            width: 30px;
            height: 30px;
            background-color: #000;
            opacity: 0.06;
            border-radius: 50%;
          }
        }
      }
    }

    .title {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #0085FF;
      font-size: 22px;
      font-weight: 600;
      line-height: 100%;

      &:before {
        margin-right: 12px;
        content: '';
        display: block;
        width: 1px;
        height: 12px;
        background: #D9D9D9;
      }

      &-desc {
        display: flex;
        align-items: center;
        gap: 20px;
        color: #2F2F2F;
        font-size: 13px;
        font-weight: 400;
      }
    }
  }
  .gnb__navigation {
    position: absolute;
    top: 47px;
    right: 25px;
    z-index: 10000001;
    width: 220px;
    border-radius: 14px;
    box-shadow: 0 16px 15px -4px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    padding-bottom: 12px;

    .home {
      display: flex;
      align-items: center;
      column-gap: 5px;

      padding-top: 15px;
      padding-left: 20px;

      cursor: pointer;

      &__icon {
        box-sizing: border-box;
        width: 34px;
        height: 34px;
        padding: 9px;
        border-radius: 20px;
        border: solid 1px #bbb;
        background: url(../assets/img/icon-home.svg) no-repeat center center;
        background-color: #fff;
      }

      &__text {
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #2f2f2f;
      }
    }

    .user-name {
      display: flex;
      column-gap: 5px;
      padding-top: 15px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 12px;

      span {
        word-break: break-all;
        max-width: 100%;
        color: #3096a7;
        font-size: 13px;
        font-weight: 600;
        text-overflow: ellipsis;
        overflow: hidden;
        box-sizing: border-box;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 1.62;
      }

      .icon--setting {
        margin-top: 2.5px;
      }
    }

    & > ul {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;

      li {
        padding: 7px 10px;
        box-sizing: border-box;
        position: relative;

        &.item__title {
          height: auto;
          padding-top: 20px;
          border-top: 1px solid #d7d7d7;

          font-size: 12px;
          font-weight: 700;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: normal;
          color: #999;
        }

        &.item__signout {
          height: auto;
          padding-top: 15px;
          padding-bottom: 0px;
          border-top: 1px solid #d7d7d7;
        }

        &.item__language {
          display: flex;
          align-items: center;
          height: 50px;
          padding: 12px 0px 0px 0px;
        }

        &.divlist {
          padding: 0px 10px;

          a {
            display: block;
            padding-left: 13px;
            color: #444444;
            border-radius: 20px;
            cursor: pointer;
            font-size: 13px;
            height: 27px;
            line-height: 27px;

            &::before {
              content: "•";
              color: #999999;
            }

            &:hover {
              background-color: #ebebeb;
            }
          }
        }

        &.item--last {
          margin-bottom: 7px;
        }

        .item {
          display: inline-block;
          width: 100%;
          height: 27px;
          line-height: 27px;
          font-size: 14px;
          color: #2f2f2f;
          padding-left: 10px;
          box-sizing: border-box;
          border-radius: 12px;

        }

        &:hover .item:not(.item-language):not(.signout) {
          background-color: #ebebeb;
        }

        &.item--common {
          padding: 0px;
          padding-top: 7px;
          margin: 7px 10px;
          border-top: 1px dashed #d1d1d1;
        }

        .signout {
          display: block;
          margin: 0 auto;
          width: 180px;
          height: 34px;
          border-radius: 20px;
          border: solid 1px #bbbbbb;
          background-color: #ffffff;
          padding-left: 0;
          text-align: center;
          line-height: 32px;
        }

        .language--wrap {
          position: absolute;
          top: 12px;
          right: 0;
          width: 98px;
          height: 38px;
          border-radius: 6px;
          border: solid 1px #bbbbbb;
          background-color: #ffffff;
          box-sizing: border-box;

          .current-language,
          .language__list li{
            display: inline-block;
            width: 100%;
            height: 100%;
            line-height: 36px;
            padding-left: 6px;
            box-sizing: border-box;

            font-size: 14px;
            color: #2f2f2f;
            cursor: pointer;

            .icon--lang {
              vertical-align: middle;
              margin-right: 5px;
              position: relative;
              top: -1px;
            }
          }

          .language__list {
            width: 98px;
            border-radius: 6px;
            box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.25);
            background-color: #ffffff;
            overflow: hidden;
            position: absolute;
            top: -1px;
            left: -1px;
            z-index: 1;

            opacity: 0;
            transform-origin: top;
            transition: transform .2s ease, opacity .1s ease;

            &.is-show {
              opacity: 1;
            }

            li:hover {
              background-color: #ebebeb;
            }
          }

          .icon--drop-down {
            pointer-events: none;
            position: absolute;
            top: 50%;
            right: 12px;
            transform: translateY(-50%);
          }

          .slide-enter, .slide-leave-to{
            transform: scaleY(0);
            opacity: 0;
          }
        }
      }
    }
  }
}

</style>
